import React from "react";
import Blog from "../../lib/Pages/Blog";

function BlogPage() {
  return <Blog />;
}

export default BlogPage
